import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeaker12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSpeaker12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Speaker12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M9.053 1.777a.5.5 0 0 1 .67-.224L9.5 2l.224-.447.002.001.003.002.009.004.107.062q.104.06.268.181c.215.162.497.41.777.76C11.456 3.27 12 4.379 12 6c0 1.618-.53 2.725-1.081 3.433a4.3 4.3 0 0 1-.76.76 3 3 0 0 1-.343.23l-.025.015-.008.004-.004.002h-.001s-.001.001-.227-.44l.226.441a.5.5 0 0 1-.46-.888l-.054-1.61a3.4 3.4 0 0 1-.443.438l-.014.01L8.8 8.4l-.002.002-.299-.4.298.4a.5.5 0 0 1-.598-.8l.003-.003.02-.017q.03-.024.089-.079a2.4 2.4 0 0 0 .284-.325C8.806 6.891 9 6.492 9 6s-.195-.89-.404-1.177a2.4 2.4 0 0 0-.393-.42L8.2 4.4a.5.5 0 0 1 .598-.801L8.5 4l.298-.401H8.8l.002.002.005.004.014.01.043.035a3 3 0 0 1 .262.248L9.07 2.254l.056 1.644c.086.091.183.204.279.336.29.399.596 1 .596 1.766a3 3 0 0 1-.596 1.767 4 4 0 0 1-.141.18l.055 1.61.007-.004.043-.026c.041-.025.104-.067.18-.126.156-.12.368-.31.582-.584.424-.542.87-1.435.87-2.817 0-1.378-.456-2.27-.89-2.813a3.3 3.3 0 0 0-.598-.584 2 2 0 0 0-.23-.153l-.008-.004a.5.5 0 0 1-.22-.67M3.57 5h.376l.283-.247L6 3.203v5.593L4.23 7.248 3.947 7H2V5zM1 5a1 1 0 0 1 1-1h1.571l2.6-2.274A.5.5 0 0 1 7 2.102v7.796a.5.5 0 0 1-.83.377L3.572 8H2a1 1 0 0 1-1-1z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Speaker12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconSpeaker12);
